export default __webpack_public_path__ + "static/media/swipe.bbf13d30.svg";